import { useState } from "react";
import { Link2, Check } from "lucide-react";
import { toast } from "sonner";

// Copies a shareable, deep-linkable URL to the clipboard.
// Pass a path (e.g. "/events/123") or a full URL.
export const ShareButton = ({ path, label = "Copy link", testid = "share-link-btn", className = "" }) => {
  const [copied, setCopied] = useState(false);
  const url = path?.startsWith("http") ? path : `${window.location.origin}${path}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Link copied — share it anywhere");
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <button type="button" onClick={copy} data-testid={testid} title={`Copy link: ${url}`}
      className={`inline-flex items-center gap-1.5 rounded-full border border-[#144F75]/20 px-3 py-1.5 text-xs font-medium text-[#144F75] hover:bg-[#144F75]/[0.06] transition-colors ${className}`}>
      {copied ? <Check size={13} /> : <Link2 size={13} />} {copied ? "Copied" : label}
    </button>
  );
};
